import { useId } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CampaignTerms } from "./legal/CampaignTerms";
import { MembershipTerms } from "./legal/MembershipTerms";
import { PrivacyProvisions } from "./legal/PrivacyProvisions";

export { NOTICE_VERSION } from "./legal/LegalPrimitives";

export const safePolicyUrl = (value) => {
  try { const url = new URL(value); return ["https:", "http:"].includes(url.protocol) && url.hostname ? url.href : null; }
  catch { return null; }
};

export const TermsContent = ({ organisation, variant = "campaign" }) => (
  <div data-testid="terms-content">
    {variant === "membership" ? <MembershipTerms organisation={organisation} /> : <CampaignTerms organisation={organisation} />}
  </div>
);

export const PrivacyContent = ({ organisation, variant = "campaign" }) => (
  <div data-testid="privacy-content"><PrivacyProvisions organisation={organisation} variant={variant} standalone /></div>
);

export const ParticipationConsent = ({ checked, onChange, onTerms, prefix = "participation", checkboxTestId }) => {
  const labelId = useId();
  return (
    <div data-testid={`${prefix}-collection-notice`} className="flex items-start gap-2 text-xs leading-relaxed">
      <input id={`${labelId}-checkbox`} className="mt-0.5 shrink-0 cursor-pointer" data-testid={checkboxTestId || `${prefix}-consent-checkbox`} type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} aria-labelledby={labelId} />
      <span id={labelId} data-testid={`${prefix}-consent-label`}><label htmlFor={`${labelId}-checkbox`} className="cursor-pointer">I agree with the </label><button type="button" data-testid={`${prefix}-terms-button`} className="underline underline-offset-2 hover:opacity-75 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 transition-opacity" onClick={onTerms}>Terms and Conditions</button></span>
    </div>
  );
};

export const TermsDialog = ({ open, onOpenChange, organisation, variant = "campaign" }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="terms-dialog" className="w-[calc(100%-2rem)] max-w-2xl max-h-[85dvh] overflow-y-auto bg-white text-neutral-900" style={{ fontFamily: "'Source Sans Pro', sans-serif", letterSpacing: 0 }}>
      <DialogHeader>
        <DialogTitle data-testid="terms-dialog-title" className="uppercase text-base">Terms and Conditions</DialogTitle>
        <DialogDescription data-testid="terms-dialog-description" className="sr-only">Terms governing participation and the handling of personal information.</DialogDescription>
      </DialogHeader>
      <TermsContent organisation={organisation} variant={variant} />
      <button type="button" data-testid="terms-dialog-close" className="justify-self-end underline text-xs uppercase underline-offset-2 hover:opacity-75 transition-opacity" onClick={() => onOpenChange(false)}>Close</button>
    </DialogContent>
  </Dialog>
);